export default function ChatLanding() {

    return <></>
}

